import { FC } from 'react'

import { ISvgClass } from '../interface'

const ChevronPaginationIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00003 18.586C7.60956 18.9764 7.60956 19.6095 8.00003 20C8.39049 20.3904 9.02357 20.3904 9.41403 20L16.7069 12.7071C17.0974 12.3165 17.0974 11.6834 16.7069 11.2929L9.41403 3.99997C9.02356 3.6095 8.39049 3.6095 8.00003 3.99997C7.60956 4.39043 7.60956 5.0235 8.00003 5.41397L13.8789 11.2929C14.2694 11.6834 14.2694 12.3166 13.8789 12.7071L8.00003 18.586Z"
        fill="inherit"
      />
    </svg>
  )
}

export default ChevronPaginationIcon
